import React from 'react';
import {useNavigate} from 'react-router';
import {RsnButton, RsnDialog} from '~/library/ui-kit';

export function CouldNotSendDialog({onAnotherNumber}: {onAnotherNumber?: () => void}) {
    const navigate = useNavigate();
    const {onClose} = RsnDialog.useControls();
    const handleAnotherNumber = onAnotherNumber ?? onClose;
    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={'alert'} />}}>
                We couldn’t send the <span className={'whitespace-nowrap'}>verification code</span>
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>
                Check the phone number and try again, <span className={'whitespace-nowrap'}>or contact support.</span>
            </RsnDialog.Body>
            <RsnDialog.Footer column>
                <RsnButton.Primary onClick={handleAnotherNumber}>Use another number</RsnButton.Primary>
                <RsnButton.Secondary onClick={() => navigate('/support/form')}>Contact support</RsnButton.Secondary>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
